import { ToastActions, ToastStateType } from './toastType';

const toastReducer = (state: ToastStateType, action: ToastActions): ToastStateType => {
    switch (action.type) {
        case 'SET_TOAST':
            // prevent toast from being set again;
            if (state.toast.find(({ id }) => id === action.payload.id)) return state;

            return {
                ...state,
                toast: [...state.toast, action.payload],
            };
        case 'REMOVE_TOAST':
            return {
                ...state,
                toast: state.toast.filter(({ id }) => id !== action.payload),
            };
        default:
            return state;
    }
};

export default toastReducer;
